import React, { Component } from "react";
import { DatePicker } from "antd";
import moment from "moment";
import PropTypes from 'prop-types';
import Pricetable from "../priceTable/priceTable";
import { DataValue, DisplayFlex, SecondaryButtonComponentForLightText } from "../../../../../../CommonComponents/commonStyles";
import { startDate, todayDate, recordError } from "../../../../../../utils/commonUtil";
/*************************/
import { fetchUnderlyingTableData } from "../../action";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { NAVCalendar } from "../../styles";
import { investmentHistoricNavDerivedStates } from "../../selectors"
import { CapsuleButton } from "../../../../../../CommonComponents/Commons/commonComponents";
const dateFormatList = "MM/DD/YYYY";
class HistoricNav extends Component {
  constructor(props) {
    super(props);
    this.state = {
      startDate: startDate(90),
      endDate: todayDate(),
      submit: true,
      priceTableData: [],
      apiCalled: false,
      toggleSearch: false
    };
    this.filterdate = this.filterdate.bind(this);
  }

  /****************************************/
  setStartDate = date => {       
    if (date) {
      if (!this.state.submit) this.state.submit = true;
      this.setState({
        startDate: moment(date._d).format("MM/DD/YYYY")
      });
    }
  };

  setEndDate = date => {    
    if (date) {
      if (!this.state.submit) this.state.submit = true;
      this.setState(
        {
          endDate: moment(date._d).format("MM/DD/YYYY")
        },
        () => {}
      );
    }
  };

  filterdate = poolId => {
    try {
      this.setState({ apiCalled: true, toggleSearch: true }, () => {
        this.props.requestData({
          metaData: {
            method: "GET",
            url: `/donor-portal/api/investmentOptions/findFundPerformanceByPoolIdAndStartDateAndEndDate?poolId=${poolId}&startDateStr=${
              this.state.startDate
            }&endDateStr=${this.state.endDate}`,
            page: "investmentOptionDetails"
          }
        });
      });
    } catch (error) {
      recordError(error);
    }
  };

  componentWillReceiveProps(nextprops) {    

    if(this.state.toggleSearch) {      
      this.setState({
        priceTableData: nextprops.tableData.hasOwnProperty("prices")
          ? nextprops.tableData.prices
          : [],
        submit: !this.state.submit,
        toggleSearch: false
      });
    }

    if (this.state.submit === false) {
      const { priceTable } = this.props;

      this.setState({
        startDate: moment(new Date())
          .subtract(90, "days")
          .format("MM/DD/YYYY"),
        endDate: moment(new Date()).format("MM/DD/YYYY"),
        priceTableData: priceTable
      });
    }
  }


  render() {
    const { priceTable, record, accountType } = this.props;
    return (
      <div className="mr3 flex-shrink">
        <DataValue className="mb1 navy-color">
          Search for Historical NAV
        </DataValue>
        <DisplayFlex>
          <NAVCalendar>
            <DatePicker
              data-test="startDate"
              onChange={this.setStartDate}
              placeholder="Select Start Date"
              allowClear={false}
              disabledDate={current => {
                return current && current.valueOf() > moment(this.state.endDate);
              }}
              format={dateFormatList}
              value={moment(this.state.startDate)}
              className="mb2 mr1"
            />
          </NAVCalendar>
          <NAVCalendar>
            <DatePicker
              onChange={this.setEndDate}
              allowClear={false}
              placeholder="Select End Date"
              disabledDate={current => {
                return current && current.valueOf() < moment(this.state.startDate);
              }}
              format={dateFormatList}
              value={moment(this.state.endDate)}
              className="mb2"
            />
          </NAVCalendar>
        </DisplayFlex>
        {this.state.submit === true ? (

      <CapsuleButton fontSize="16px" text="Search" onClick={() => this.filterdate(record.poolId)} data-test="searchBtn" whiteBackground styles="basicButton"/>

        ) : (

          <CapsuleButton text="Reset to default" onClick={() => this.filterdate(record.poolId)} data-test="resetButton"  whiteBackground fontSize="16px" styles=" basicButton-auto"/>
              
        )}

        <div>
          {this.state.apiCalled ? (
            <Pricetable
              loader={this.props.isLoadingUnderlyingTable}
              data={this.state.priceTableData}
              accountType={accountType}
              tabName={this.props.record.type}
            />
          ) : (
            <Pricetable
              loader={this.props.isLoadingUnderlyingTable}
              data={priceTable}
              accountType={accountType}
              tabName={this.props.record.type}
            />
          )}
        </div>
      </div>
    );
  }
}

HistoricNav.propTypes = {
  priceTable: PropTypes.array,
  accountID:  PropTypes.string,
  accountType:  PropTypes.string,
  record:  PropTypes.object,
  requestData:  PropTypes.func,
  tableData:  PropTypes.object
}

const mapStateToProps = state => ({  
  ...investmentHistoricNavDerivedStates(state.toJS())
   });

const mapDispatchToProps = dispatch => ({
  requestData: data => dispatch(fetchUnderlyingTableData(data))
});

export default withRouter(
  connect(
    mapStateToProps,
    mapDispatchToProps
  )(HistoricNav)
);
